import { render, staticRenderFns } from "./GTUserMappingEdit.vue?vue&type=template&id=2e336830&scoped=true"
import script from "./GTUserMappingEdit.vue?vue&type=script&lang=js"
export * from "./GTUserMappingEdit.vue?vue&type=script&lang=js"
import style0 from "./GTUserMappingEdit.vue?vue&type=style&index=0&id=2e336830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e336830",
  null
  
)

export default component.exports